/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-07-06 15:03:14
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-08-04 15:39:23
 * @FilePath: \xm-runing-main\src\components\xm-tenant-and-industry-toggle\stores\xm-tenant-select.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { DropdownProps, MenuProps } from 'ant-design-vue'
import {listToSelItem, useXmAgentAndIndustryToggleStore} from '.'
import { useXmTenantModalStore } from './xm-tenant-modal'
import { useXmTenantFormStore } from './xm-tenant-form'
import {dbUtils} from 'xmgoing-utils'
import {StorageUtils} from 'xmgoing-utils';

export const useXmTenantDropdownStore = defineStore('xm-tenant-dropdown', () => {
  const XmAgentAndIndustryToggleStore = useXmAgentAndIndustryToggleStore()
  const XmTenantModalStore = useXmTenantModalStore()
  const XmTenantFormStore = useXmTenantFormStore();

  const {
    tenantList
  } = storeToRefs(XmAgentAndIndustryToggleStore)

  const {
    visible
  } = storeToRefs(XmTenantModalStore)

  const {
    model
  } = storeToRefs(XmTenantFormStore)

  const dropdownProps = computed<DropdownProps>(() => {
    return {
      placement: 'bottomRight'
    }
  })
  //历史租户编码
  const oldTenantCode = ref('');
  //租户编码
  const tenantCode = ref(StorageUtils.getSessionItem("tenantCode"));
  const selectedKeys = computed(() => {
    return [tenantCode.value]
  })

  const menuProps = computed<MenuProps>(() => {
    return {
      selectable: true,
      selectedKeys: selectedKeys.value,
    }
  })

  /**
   * 获取当前租户标题
   */
  const currentTitle = computed(() => {
    const userInfo = dbUtils.getCachUser();
    tenantCode.value=userInfo?.id;
    if(unref(userInfo)?.realName){
      return unref(userInfo)?.tenantName||''+`(${unref(userInfo)?.realName||''})`
    }else{
      return ''
    }
  })

  /**
   * 点击显示 弹出密码修改框
   * @param selectedKeys
   * @param keyPath
   */
  const onSelect: MenuProps['onSelect'] = ({selectedKeys, keyPath}) => {
    if (tenantCode.value === selectedKeys.at(0)) {
      return
    }
    model.value.tenantCode = keyPath as string[]
    visible.value = true
  }

  function reset () {
    tenantCode.value = ''
  }

  watch(visible, () => {
    if (!visible.value) {
      reset()

      tenantCode.value = ''

      nextTick(() => {
        tenantCode.value = oldTenantCode.value
      })
    }
  })



  return {
    currentTitle,
    dropdownProps,
    menuProps,
    tenantList,
    onSelect
  }
})
